export const OVERALL_LABEL: Record<string, string> = {
  mostly_positive: "Mostly Positive",
  mixed: "Mixed",
  challenging: "Challenging",
};

export const OVERALL_COLOR: Record<string, string> = {
  mostly_positive: "var(--color-success)",
  mixed: "var(--color-warning-gold)",
  challenging: "var(--color-error)",
};
